// :cow: Cosmose CONFIDENTIAL :iso:
import { Component } from '@angular/core';

@Component({
  selector: 'e-page-403',
  templateUrl: 'page-403.component.html',
})
export class Page403Component {
}
